import React from 'react';
(window as any).React = React;
